<template>  
<div class="container font" style="height:100%">
    <div class="d-flex flex-column justify-content-between" style="height:100%">
        <div class="textbox_label">
                  配图设置:
                 </div>
                 <div class="text-secondary">默认不设封面，正文使用备忘录</div>
                 <div class="d-flex justify-content-start mt-1">
                    <label class="btn" :class="cover_types==0?'btn-primary':' btn-secondary'" @click="setCover(0)">封面</label>
                    <label v-if="selected_cover==undefined || selected_cover.linked_content==undefined" class="btn ml-1" :class="cover_types==1?'btn-primary':' btn-secondary'" @click="setCover(1)">正文</label>
                 </div>
              <div class="tm_box flex-fill">
                 

                 <div class="row d-flex justify-content-center">
                 
                    <div v-for="(template,index) in templates" :key="index" >
                        <div v-if="template.default_img!=undefined&&( (cover_types==1&&!template.cover_only)||(cover_types==0&& template.cover_only))" class="col m-1" @click="choose(template)">

                                <img :src="template.default_img" :class="(cover_types==0&& selected_cover['objectId']==template.objectId)||(cover_types==1&& selected_content['objectId']==template.objectId)?'img selected':'img'" >

                        </div>
                    </div>
                 </div>
                
               
              </div>

              <div class="d-flex justify-content-center">
                <button class="btn normalBtn" @click="finish">完成</button>
              </div>
             
            </div>
        </div>
             
         
          
   
   
   </template>
   
   <script>
   import axios from 'axios';

   
   export default {
     data(){
      
  
       return {
        
        cover_types:0,
         templates:null,
         selected_cover:null,
         selected_content:null
       }
     },
     props: ["isUpdate","accountId"],
     components: {

      
     },
      setup(){
       
        var token=localStorage.getItem('sessionToken')
        axios.defaults.headers.common['X-Parse-Session-Token'] = token
   
     },
   
  
     mounted(){ 
        this.getTemplates()
    },
     methods:{
        finish(){

            this.$emit('set_template', {'cover':this.selected_cover,'content':this.selected_content});
        },
        setCover(t){
        this.cover_types=t
      },
      choose(id){
        if(this.cover_types==0)
        {
            this.selected_cover=id
            console.log(this.selected_cover)
        }
        else
        {
            this.selected_content=id
        }

      },
      
      async getTemplates(){
      try{
          this.isLoading=true
          const response = await axios.get(this.domain+'xhs/get_templates');

          var data=response.data
          if(data.status=='Suc')
          {
              this.templates=data['templates']
              var empty_cover={"cover_only":true,"default_img":'https://xhs-template.oss-cn-shanghai.aliyuncs.com/empty_cover.png',"objectId":undefined}
              var empty_content={"default_img":'https://xhs-template.oss-cn-shanghai.aliyuncs.com/empty_content.png',"objectId":undefined}
              this.templates.unshift(empty_cover)
              this.templates.unshift(empty_content)
             
              this.selected_cover=empty_cover
              this.selected_content=data['default']
               
            
          }
          else
          {
              console.error(data)
              
          }
      }
      catch(error)
      {
          console.error(data)
      }
      finally{
        this.isLoading=false
      }
    },
   
       },
      
     
   };
   </script>
   <style scoped>
  .img{
    width: 2rem;
    min-height:2rem;
    border:1px solid gray;
  }
  .tm_box{
    overflow-y: auto;
    overflow-x: hidden
  }
  .selected{
    border:0.025rem solid #ec2151
  }
   </style>
   
   
   